import React, { Suspense, useState, useEffect, useRef } from "react";
import { Modal } from 'react-responsive-modal';
import Drawer from 'react-modern-drawer';

export default function AdvancedSearchBox(param: any) {

    let [hold, setHold] = useState(false);
    let [monthly, setMonthly] = useState(true);
    let [crossed, setCrossed] = useState(true);
    let [quarterly, setQuarterly] = useState(true);
    let [uncrossed, setUncrossed] = useState(true);
    let [royalties, setRoyalties] = useState(true);
    let [publisher, setPublisher] = useState(false);
    let [biAnnually, setBiAnnually] = useState(true);
    let [mechanical, setMechanical] = useState(false);
    let [viewAllStatus, setViewAllStatus] = useState(true);

    const returnValue = (e: any) => {
        param.onChange(e)
    }

    let [saveAlertInvoice, setsaveAlertInvoice] = useState(false);
    let [refError, setrefError] = useState(false);

    const onClose = () => {
        param.AdvancedSearchClose();
    }

    var payload = { paymentType: "Contact", hold: true, showZeroBal: true, crossed: true, uncrossed: true, royalty: true, publisher: true, mechanical: true, biannual: 3, quarterly: 2, monthly: 1 }
    let [Final_search_payload, setFinal_search_payload] = useState<any>([])
    const Search = () => {
        Final_search_payload = { ...payload }
        if (!monthly) {
            const search_payload = Object.fromEntries(Object.entries(Final_search_payload).filter(([key]) => key !== "monthly"));
            Final_search_payload = search_payload
            console.log(Final_search_payload)
            setFinal_search_payload(Final_search_payload)
        }

        if (!quarterly) {
            const search_payload = Object.fromEntries(Object.entries(Final_search_payload).filter(([key]) => key !== "quarterly"));
            Final_search_payload = search_payload
            console.log(Final_search_payload)
            setFinal_search_payload(Final_search_payload)
        }

        if (!biAnnually) {
            const search_payload = Object.fromEntries(Object.entries(Final_search_payload).filter(([key]) => key !== "biannual"));
            Final_search_payload = search_payload
            console.log(Final_search_payload)
            setFinal_search_payload(Final_search_payload)
        }

        if (!royalties) {
            const search_payload = Object.fromEntries(Object.entries(Final_search_payload).filter(([key]) => key !== "royalty"));
            Final_search_payload = search_payload
            console.log(Final_search_payload)
            setFinal_search_payload(Final_search_payload)
        }

        if (!mechanical) {
            const search_payload = Object.fromEntries(Object.entries(Final_search_payload).filter(([key]) => key !== "mechanical"));
            Final_search_payload = search_payload
            console.log(Final_search_payload)
            setFinal_search_payload(Final_search_payload)
        }

        if (!publisher) {
            const search_payload = Object.fromEntries(Object.entries(Final_search_payload).filter(([key]) => key !== "publisher"));
            Final_search_payload = search_payload
            console.log(Final_search_payload)
            setFinal_search_payload(Final_search_payload)
        }

        if (!hold) {
            const search_payload = Object.fromEntries(Object.entries(Final_search_payload).filter(([key]) => key !== "hold"));
            Final_search_payload = search_payload
            console.log(Final_search_payload)
            setFinal_search_payload(Final_search_payload)
        }

        if (!crossed) {
            const search_payload = Object.fromEntries(Object.entries(Final_search_payload).filter(([key]) => key !== "crossed"));
            Final_search_payload = search_payload
            console.log(Final_search_payload)
            setFinal_search_payload(Final_search_payload)
        }

        if (!uncrossed) {
            const search_payload = Object.fromEntries(Object.entries(Final_search_payload).filter(([key]) => key !== "uncrossed"));
            Final_search_payload = search_payload
            console.log(Final_search_payload)
            setFinal_search_payload(Final_search_payload)
        }
        console.log(Final_search_payload)
        param.AdvancedSearchClose(Final_search_payload)
    }

    return (
        <>
            <Drawer open={param.param} direction='right' className='react-drawer allowVscroll allowHscroll' size={800}>

                <div className="box noBorderRadius noBorder full-height-vh allowVscroll pull-right ws-6">

                    <div className="box-header-main"> <h2 className="ws-8"> Search </h2></div>

                    <div className="box-content">
                        <div className="alert alert-warning hide" data-ng-show="resetFormValues">
                            The search criteria has been modified. Please click on Search to get updated results
                        </div>

                        <div className="form-format ws-12">
                            <div className="form-format ws-5">
                                <label className="control-label">Period:  </label>
                                <div className="label-entries">
                                    <select data-ng-model="period" title="Choose a period" data-ng-change="showResetWarning(period)">
                                        <option ng-selected="item.suggestedPaymentPeriod == 1" value="20140331" >
                                            Jan 1, 2014 - Mar 31, 2014
                                        </option>
                                    </select>
                                </div>

                            </div>

                            <div className="form-format ws-7">
                                <label className="control-label">Contact/Contract/Batch Search:  </label>
                                <div className="label-entries">
                                    <input data-ng-model="search.contact" type="text" placeholder="Enter a search query" id="Contact" name="Contact" />
                                </div>
                            </div>

                        </div>

                        <div className="form-format ws-12">
                            <label className="control-label">Accounting:</label>

                            <div className="label-entries ws-4 mtl">
                                <div className="ws-4">Monthly</div>
                                <label className="switch ws-6 mr">
                                    <input type="checkbox" checked={monthly} onChange={() => setMonthly(!monthly)} />
                                    {monthly && <span className="slider round text-left white pm pts">Yes</span>}
                                    {!monthly && <span className="slider round text-right white pm pts sliderOff">No</span>}
                                </label>
                            </div>
                            <div className="label-entries ws-4 mtl">
                                <div className="ws-4">Quarterly</div>
                                <label className="switch ws-6 mr">
                                    <input type="checkbox" checked={quarterly} onChange={() => setQuarterly(!quarterly)} />
                                    {quarterly && <span className="slider round text-left white pm pts">Yes</span>}
                                    {!quarterly && <span className="slider round text-right white pm pts sliderOff">No</span>}
                                </label>
                            </div>
                            <div className="label-entries ws-4 mtl">
                                <div className="ws-4">Bi-annually</div>
                                <label className="switch ws-6 mr">
                                    <input type="checkbox" checked={biAnnually} onChange={() => setBiAnnually(!biAnnually)} />
                                    {biAnnually && <span className="slider round text-left white pm pts">Yes</span>}
                                    {!biAnnually && <span className="slider round text-right white pm pts sliderOff">No</span>}
                                </label>
                            </div>
                        </div>

                        <div className="form-format ws-12">

                            <div className="form-format ws-4">
                                <div className="ws-4" title="Includes zero balances and Negative balances">View All Status</div>
                                <label className="switch ws-6 mr">
                                    <input type="checkbox" checked={viewAllStatus} onChange={() => setViewAllStatus(!viewAllStatus)} />
                                    {viewAllStatus && <span className="slider round text-left white pm pts">Yes</span>}
                                    {!viewAllStatus && <span className="slider round text-right white pm pts sliderOff">No</span>}
                                </label>
                            </div>
                            <div className="form-format ws-4">
                                <div className="ws-4">Crossed</div>
                                <label className="switch ws-6 mr">
                                    <input type="checkbox" checked={crossed} onChange={() => setCrossed(!crossed)} />
                                    {crossed && <span className="slider round text-left white pm pts">Yes</span>}
                                    {!crossed && <span className="slider round text-right white pm pts sliderOff">No</span>}
                                </label>
                            </div>
                            <div className="form-format ws-4">
                                <div className="ws-4">Uncrossed</div>
                                <label className="switch ws-6 mr">
                                    <input type="checkbox" checked={uncrossed} onChange={() => setUncrossed(!uncrossed)} />
                                    {uncrossed && <span className="slider round text-left white pm pts">Yes</span>}
                                    {!uncrossed && <span className="slider round text-right white pm pts sliderOff">No</span>}
                                </label>
                            </div>
                        </div>

                        <div className="form-format ws-12">

                            <div className="form-format ws-4">
                                <div className="ws-4">Royalties</div>
                                <label className="switch ws-6 mr">
                                    <input type="checkbox" checked={royalties} onChange={() => setRoyalties(!royalties)} />
                                    {royalties && <span className="slider round text-left white pm pts">Yes</span>}
                                    {!royalties && <span className="slider round text-right white pm pts sliderOff">No</span>}
                                </label>
                            </div>

                            <div className="form-format ws-4">
                                <div className="ws-4">Mechanical</div>
                                <label className="switch ws-6 mr">
                                    <input type="checkbox" checked={mechanical} onChange={() => setMechanical(!mechanical)} />
                                    {mechanical && <span className="slimder round text-left white pm pts">Yes</span>}
                                    {!mechanical && <span className="slider round text-right white pm pts sliderOff">No</span>}
                                </label>
                            </div>

                            <div className="form-format ws-4">
                                <div className="ws-4">Publisher</div>
                                <label className="switch ws-6 mr">
                                    <input type="checkbox" checked={publisher} onChange={() => setPublisher(!publisher)} />
                                    {publisher && <span className="slider round text-left white pm pts">Yes</span>}
                                    {!publisher && <span className="slider round text-right white pm pts sliderOff">No</span>}
                                </label>
                            </div>
                        </div>

                        <div className="form-format ws-12">
                            <div className="form-format ws-4">
                                <div className="ws-4">Hold</div>
                                <label className="switch ws-6 mr">
                                    <input type="checkbox" checked={hold} onChange={() => setHold(!hold)} />
                                    {hold && <span className="slider round text-left white pm pts" >Yes</span>}
                                    {!hold && <span className="slider round text-right white pm pts sliderOff">No</span>}
                                </label>
                            </div>
                        </div>

                    </div>

                    <div className="box-footer">
                        <a className="btn icon-btn info pull-right" data-ng-click="ResetAPayment()"> Create Snapshot </a>
                        <a className="icon-btn edit pull-right" onClick={Search}> <i className="icon-search"></i> Search</a>
                        <a className="icon-btn delete pull-right" onClick={onClose}> <i className="icon-close3"></i>Close</a>
                        <a className="icon-btn delete btn-sm pull-right hide" > <i className="icon-reload"></i> Reset </a>
                    </div>

                </div>

            </Drawer>

        </>
    )
}